import React from 'react';
import styled, { css } from 'styled-components';
import { Color } from '../../../theme';
const LogoSVG = ({ className }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30", className: className },
    React.createElement("path", { className: "vodafoneLogoAnimatedStroke", d: "M5 20.6c1.3 5.7 6.2 9.1 10.8 9 6.7 0 10.7-5.6 10.7-10.6s-2.8-8.7-8.8-10.2v-.3c0-3.8 2.8-7.2 6.5-7.9-.4-.1-.9-.2-1.4-.2-4.1 0-8.7 1.8-12 4.5-2.8 2.3-5 5.8-5.8 9.6" })));
const VodafoneLogoAnimated = styled(LogoSVG) `
  ${(props) => props.height
    ? css `
          height: ${props.height};
        `
    : css `
          height: 100%;
        `};
  ${(props) => props.width
    ? css `
          width: ${props.width};
        `
    : css `
          width: 100%;
        `};

  & .vodafoneLogoAnimatedStroke {
    animation: dashVodafone 2s ease-in-out infinite;
    fill: none;
    stroke-dasharray: 85;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
    stroke-width: 1;
    stroke: ${(props) => (props.inverted ? Color.WHITE : Color.PRIMARY)};
  }

  @keyframes dashVodafone {
    50% {
      stroke-dashoffset: 85;
    }

    100% {
      stroke-dashoffset: 170;
    }
  }
`;
export default VodafoneLogoAnimated;
//# sourceMappingURL=vodafone-logo.js.map